import { Col, message, Modal, Row, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import "./UploadDataForm.css";
import { InboxOutlined, Info } from "@material-ui/icons";
import { dirname } from "util/resourcePath";
import Dragger from "antd/lib/upload/Dragger";
import GYAxios from "../../../util/GYAxios";

export const UploadDataForm = (props) => {
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [uploadedFile, setUploadedFile] = useState(null);
	const [fileList, setFileList] = useState([]);
	const ext = (props.formUploadAccept || ".csv").replace(".", "").toUpperCase();

	const uploadProps = {
		className: "custom-upload-dragger-box",
		name: "file",
		multiple: false,
		accept: props.formUploadAccept || ".csv",
		maxCount: props.formUploadMaxCount || 1,
		fileList: fileList,
		beforeUpload: (file) => {
			const isInvalid = props.formUploadIsInvalid ? props.formUploadIsInvalid(file) : false;
			if (isInvalid) {
				message.error(isInvalid);
				return false;
			}

			// Store the file but don't upload yet
			setUploadedFile(file);
			return false; // Prevent automatic upload
		},
		onChange(info) {
			let newFileList = [...info.fileList];

			// Keep only the latest file
			newFileList = newFileList.slice((props.formUploadMaxCount || 1) * -1);

			setFileList(newFileList);

			if (newFileList.length === 0) {
				setUploadedFile(null);
			}
		},
		onRemove() {
			setUploadedFile(null);
			setFileList([]);
		},
		style: {
			marginTop: "20px",
		},
	};

	useEffect(() => {
		// Reset file when upload URL changes
		setUploadedFile(null);
		setFileList([]);
	}, [props.formUploadUrl]);

	const handleSubmit = async () => {
		if (!uploadedFile) {
			message.warning(`Please upload a ${ext} file first.`);
			return;
		}

		try {
			message.loading(`Uploading and processing ${ext} file...`);

			// Upload the file
			const formData = new FormData();
			formData.append("file", uploadedFile);

			const uploadResponse = await GYAxios.post(
				props.formUploadUrl,
				formData,
				{
					headers: {
						"Content-Type": "multipart/form-data",
					},
				},
			);
			message.destroy();
			if (!uploadResponse.data.success) {
				throw new Error(uploadResponse.data.error || "Upload failed");
			}

			message.success(`${uploadedFile.name} uploaded successfully!`);

			// Reset the form
			setUploadedFile(null);
			setFileList([]);
		} catch (error) {
			message.destroy();
			console.log("error", error);
			message.error(`Error: ${error.response?.data?.error || error.message}`);
		}
	};
	return (
		<>
			<Modal
				className="custom-modal"
				centered
				open={isModalOpen}
				closeIcon={false}
				onCancel={() => {
					setIsModalOpen(false);
				}}
				footer={null}
			>
				{/* Modal Header */}
				<div className="custom-modal-header">
					<h4>
						{props.modalTitle && props.modalTitle()}
					</h4>
				</div>

				{/* Modal Body */}
				<div className="custom-modal-body">
					{props.modalContent && props.modalContent()}
				</div>

				{/* Modal Footer */}
				<div className="custom-modal-footer">
					<button
						className="btn btn-primary"
						onClick={() => setIsModalOpen(false)}
					>
						OK
					</button>
				</div>
			</Modal>

			<div style={{ padding: "20px 40px 20px 40px" }}>
				<Row>
					<Col span={24}>
						<h4>{props.formTitle}</h4>
					</Col>
				</Row>

				<Row style={{ marginTop: "10px" }}>
					<Col span={24}>
						<div className="custom-medium-font" style={{ textIndent: "2em" }}>
							{props.formDescription}
						</div>
					</Col>
				</Row>

				<Row style={{ marginTop: "20px" }}>
					<Col span={6}>
						<button
							className="btn btn-info"
							onClick={() => setIsModalOpen(true)}
						>
							More Detail
						</button>
					</Col>
				</Row>

				<Dragger {...uploadProps}>
					<p className="ant-upload-drag-icon">
						<InboxOutlined style={{ fontSize: 50, color: "#88b917" }} />
					</p>
					<p className="ant-upload-text">
						Click or drag {ext} file to this area to upload
					</p>
					<p className="ant-upload-hint">
						Support for a single upload. Only {ext} file is accepted.
					</p>
				</Dragger>

				<Row style={{ marginTop: "20px" }}>
					<Col span={6}>
						<button
							className="btn btn-success"
							disabled={!uploadedFile}
							onClick={handleSubmit}
						>
							Submit
						</button>
					</Col>
				</Row>
			</div>
		</>
	);
};
